import React from 'react';
import { StepErrorBanner } from './StepErrorBanner';

interface StepStatusProps {
    isLoading: boolean;
    isError: boolean;
    error: unknown;
    onRetry: () => void;
}

export const StepStatus: React.FC<StepStatusProps> = ({ isLoading, isError, error, onRetry }) => {
    if (isLoading) {
        return <div className='bp-step__loading'>Loading…</div>;
    }

    if (isError) {
        return (
            <div className='bp-step'>
                <StepErrorBanner
                    error={error}
                    message="We couldn't load this step."
                    onRetry={onRetry}
                />
            </div>
        );
    }

    return null;
};
